<template>
  <footer class="site_footer">
    <div class="site_container">
      <div class="site_footer_columns">
        <div>
          <img
            class="site_footer_logo"
            src="/media/logo-white.svg"
            width="869"
            height="396"
            alt="Japonia Cars"
          />
          <p>
            Import samochodów z Japonii bezpośrednio z domów aukcyjnych. Pełna
            obsługa, własny warsztat, jeden numer telefonu.
          </p>
        </div>

        <nav aria-label="Stopka">
          <p class="site_footer_heading">Nawigacja</p>
          <SiteMenu />
        </nav>

        <div>
          <p class="site_footer_heading">Kontakt</p>
          <address>
            43-100 Tychy<br />
            Ul. Wałowa 32<br />
            Tel. <a href="tel:509230500">509 230 500</a><br />
            Tel. <a href="tel:501069442">501 069 442</a><br />
            <a href="mailto:kontakt@japoniacars.pl">kontakt@japoniacars.pl</a>
          </address>
        </div>

        <div>
          <p class="site_footer_heading">Godziny otwarcia</p>
          <p><strong>Pon. - Pt.</strong><br />9:00 - 18:00</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
// The colophon: logo, navigation, contact details and opening hours.

import SiteMenu from "@/components/SiteMenu.vue";

export default {
  name: "SiteFooter",
  components: { SiteMenu },

  data() {
    // The mirrored markup had the year baked in; a clock is one less thing to
    // remember every January.
    return { year: new Date().getFullYear() };
  },
};
</script>

<style scoped>
.site_footer {
  background: var(--ink);
  color: var(--paper-line);
}

.site_footer_columns {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  padding: 60px 0 67px;
}

.site_footer_logo {
  width: 217px;
  margin-bottom: 24px;
}

.site_footer_heading {
  margin-bottom: 16px;
  color: rgba(209, 207, 207, 0.7);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.site_footer address {
  font-style: normal;
  line-height: 1.6;
}

.site_footer a {
  transition: color 0.2s ease;
}

.site_footer a:hover {
  color: var(--accent);
}

.site_footer :deep(.site_menu) {
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
}

.site_footer :deep(.site_menu a) {
  padding: 2px 0;
  color: var(--paper-line);
  line-height: 1.8;
}

.site_footer :deep(.site_menu a:hover) {
  color: var(--accent);
}

.site_footer_bottom {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  padding: 30px 0 27px;
  color: #fff;
}

.site_footer_bottom a {
  color: var(--accent);
}

@media (max-width: 1024px) {
  .site_footer_columns {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px 30px;
  }
}

@media (max-width: 600px) {
  .site_footer_columns {
    grid-template-columns: 1fr;
  }

  .site_footer_bottom {
    flex-direction: column;
    gap: 8px;
  }
}
</style>
